import { Link } from "react-router-dom";

export function Button({ to, href, onClick, children, variant = "primary", className = "", type, ...props }) {
  const base = "inline-flex items-center justify-center gap-2 text-sm font-semibold px-6 py-3 rounded-full transition-colors active:scale-95";
  const styles = {
    primary: "bg-cobalt text-white hover:bg-cobalt-hover",
    secondary: "bg-white text-ink border border-slate-200 hover:bg-slate-50",
    ghost: "text-cobalt hover:text-cobalt-hover",
    dark: "bg-ink text-white hover:bg-slate-800",
  };
  const cls = `${base} ${styles[variant]} ${className}`;
  if (to) return <Link to={to} className={cls} {...props}>{children}</Link>;
  if (href) return <a href={href} className={cls} {...props}>{children}</a>;
  return <button type={type || "button"} onClick={onClick} className={cls} {...props}>{children}</button>;
}
